import { createContext, useContext, useState } from "react";

const SESSION_KEY = "cyclojet_admin_session";
const AuthContext = createContext(null);

const ADMIN_EMAIL = process.env.REACT_APP_ADMIN_EMAIL || "admin@cyclojet.com";
const ADMIN_PASS = process.env.REACT_APP_ADMIN_PASS || "Cyclojet@2026";

export function AuthProvider({ children }) {
  const [isAuthenticated, setIsAuthenticated] = useState(
    () => sessionStorage.getItem(SESSION_KEY) === "1"
  );

  const login = (email, pass) => {
    if (!email || !pass) return "Please enter email and password";
    if (!ADMIN_EMAIL || !ADMIN_PASS) return "Login is not configured. Contact administrator.";
    if (email !== ADMIN_EMAIL || pass !== ADMIN_PASS) return "Invalid credentials.";
    sessionStorage.setItem(SESSION_KEY, "1");
    setIsAuthenticated(true);
    return null;
  };

  const logout = () => {
    sessionStorage.removeItem(SESSION_KEY);
    setIsAuthenticated(false);
  };

  return (
    <AuthContext.Provider value={{ isAuthenticated, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used within an AuthProvider");
  return ctx;
}
